import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { JobOfferPostulantService } from 'src/app/api/services/job-offer-postulant.service';
import { MESSAGES } from 'src/app/core/constant/messages';
import { LoadingComponent } from 'src/app/shared/component/loading/loading.component';
import { JobOfferPostulant } from 'src/app/shared/model/job-postulant-list';
import { ToastService } from 'src/app/shared/service/toast.service';

@Component({
  selector: 'app-user-my-jobs',
  imports: [CommonModule, LoadingComponent],
  templateUrl: './user-my-jobs.component.html',
  styles: ``,
})
export class UserMyJobsComponent implements OnInit {
  applications: JobOfferPostulant[] = [];
  isLoading: boolean = true;

  constructor(
    private jobOfferPostulantService: JobOfferPostulantService,
    private router: Router,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.jobOfferPostulantService.getJobOffersByUserId().subscribe({
      next: (res) => {
        this.applications = res.dto.jobOfferPostulants;
      },
      error: (err) => {
        this.toastService.showMessages(
          'error',
          err.error?.listMessage || [MESSAGES.GENERAL.UNKNOWN_ERROR]
        );
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  goToCompany(app: any): void {
    this.router.navigate(['/job-postulant', app.idJobOfferPostulant]);
  }

  isStepActive(status: string, step: string): boolean {
    const order = ['Enviado', 'Revisado', 'Preseleccionado', 'Seleccionado'];
    return order.indexOf(status) >= order.indexOf(step);
  }

  getTimelineWidth(status: string): string {
    switch (status) {
      case 'Enviado':
        return '25%';
      case 'Revisado':
        return '50%';
      case 'Preseleccionado':
        return '75%';
      case 'Seleccionado':
        return '100%';
      default:
        return '0%';
    }
  }
}
